import cx from 'classnames'

import styles from './SimpleHero.module.scss'

interface SimpleHeroProps {
  title?: string
  subtitle?: string
  className?: string | string[]
}

export const SimpleHero: React.FC<SimpleHeroProps> = ({ title, subtitle, className: additionalClasses, children }) => {
  return (
    <div className={cx(styles.SimpleHero, additionalClasses)}>
      <div className={styles.Content}>
        {children ? (
          children
        ) : (
          <>
            <h1>{title}</h1>
            <p>{subtitle}</p>
          </>
        )}
      </div>
    </div>
  )
}
